import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput, SingleSelect, SELECT_VAL_TYPE_INT } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, UploadButtonSM, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getval2Token } from '../../../../Login/Auth';
import { ReqLeagueDetail, league_type_attr, RespLeague, get_league_type_string } from '../../../../../item/MyStat/ItemLeague';
import { api_addLeague, api_getLeagueDetail, api_checkLeagueName } from '../../../../../api/MyStat/apiLeague';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items } from '../../../../../item/MyStat/ItemMyStatBase';


export function LeagueEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")

  const [_id, set_id] = useState("")
  const [league_id, set_league_id] = useState("")
  const [league_name, set_league_name] = useState("")
  const [team_acount, set_team_acount] = useState(0)
  const [league_name_eng, set_league_name_eng] = useState("")
  const [league_activation, set_league_activation] = useState(1)
  const [league_type, set_league_type] = useState(0)
  const [league_last_change, set_league_last_change] = useState("")
  const [league_note, set_league_note] = useState("")
  const [logo_league, set_logo_league] = useState("")
  const [logo_league_auth, set_logo_league_auth] = useState(0)
  const [logo_league_date, set_logo_league_date] = useState("")

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")


  // const [filePath, setFilePath] = useState("")
  // const [fileName, setFileName] = useState("")
  // const [fileType, setFileType] = useState("")
  // const [note, setNote] = useState("")
  // const [creatAt, setCreatAt] = useState("")

  const [file, setFile] = useState()

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("leagueEdit", id)
      console.log(obj)
      set_league_id(obj.league_id)
      // set_id(obj._id)
      // set_league_name(obj.league_name)
      // set_league_name_eng(obj.league_name_eng)
      // set_league_activation(obj.league_activation)
      // set_league_type(obj.league_type)
      // set_league_last_change(moment(obj.league_last_change).format('YYYY-MM-DD'))
      // set_league_note(obj.league_note)
      // set_logo_league(obj.logo_league)
      // set_logo_league_auth(obj.logo_league_auth)
      // set_logo_league_date(moment(obj.logo_league_date).format('YYYY-MM-DD HH:mm:ss'))
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (league_id !== undefined && league_id !== "") {
      // setIsLoading(true)
      var mReqLeagueDetail = new ReqLeagueDetail({
        league_id
      })
      getDetail(mReqLeagueDetail)
    }
  }, [league_id])

  function getDetail(mReqLeagueDetail) {
    console.log(mReqLeagueDetail)
    setIsLoading(true)
    api_getLeagueDetail({
      mReqLeagueDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespLeague = new RespLeague({})
        mRespLeague.fromJson(jsonData.detail)
        
      set_id(mRespLeague._id)
      set_league_name(mRespLeague.league_name)
      set_league_name_eng(mRespLeague.league_name_eng)
      set_league_activation(mRespLeague.league_activation)
      set_league_type(mRespLeague.league_type)
      set_league_last_change(moment(mRespLeague.league_last_change).format('YYYY-MM-DD'))
      set_league_note(mRespLeague.league_note)
      set_logo_league(mRespLeague.logo_league)
      set_logo_league_auth(mRespLeague.logo_league_auth)
      set_logo_league_date(moment(mRespLeague.logo_league_date).format('YYYY-MM-DD HH:mm:ss'))

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function checkName(val){
    setIsLoading(true)
    var mRespLeague = new RespLeague({
      league_name: val,
    })
    console.log(mRespLeague)
    api_checkLeagueName({
      mRespLeague,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        setCheckRepeat(true)
        if(jsonData.id === ""){
          setRepeat(false)
          setRepeatMessage("此聯盟名稱無重覆")
        }else{
          setRepeat(true)
          setRepeatMessage("與聯盟編號"+jsonData.id+"同名")
        }
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit() {
    window.location.assign("/League_Edit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    // console.log(league_type)
    var inputError = []
    if (league_name === "") {
      inputError.push("中文名字")
    }
    if (league_type === 0) {
      inputError.push("賽事類型")
    }

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    setIsLoading(true)
    var mRespLeague = new RespLeague({
      league_id,
      league_name,
      league_name_eng,
      league_type,
      league_activation,
      league_last_change,
      league_note,
      logo_league,
      logo_league_auth,
      logo_league_date
    })

    console.log(mRespLeague)
    api_addLeague({
      isAdd,
      mRespLeague,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "聯盟" + (isAdd ? "新增" : isEdit ? "編輯" : "檢視")
  var content =
    <>
      <div className="row">
        <div className="col-md-12">

          <div className="col-md-6">
            <UploadPhoto
              title={"聯盟標誌"}
              Photo={logo_league}
              PhotoAuth={logo_league_auth}
              PhotoDate={logo_league_date}
              setIsLoading={setIsLoading}
              set_Photo={set_logo_league}
              set_PhotoAuth={set_logo_league_auth}
              set_PhotoDate={set_logo_league_date}
              isEdit={isEdit}
            />
            {/* <div className="ibox float-e-margins">
              <div className="ibox-content no-padding profile-content">
                <h4>聯盟標誌</h4>
              </div>
              <div>
                <div className="ibox-content no-padding border-left-right">
                  <img alt="聯盟標誌" className="img-responsive"
                    src={logo_league === "" ? "img/profile_big.jpg" : SERVER_URL + logo_league} width="590" height="393" />
                </div>
                <div className="ibox-content profile-content">
                  <div className="row">
                    <div className="col-md-8">
                      <p>照片比例為 9:16
                        {
                          logo_league === "" ?
                            <></>
                            : <> ; 上傳日期 {moment(logo_league_date).format('YYYY-MM-DD')}</>
                        }
                      </p>
                    </div>
                    {
                      isEdit ?
                        <SingleRedio
                          arr={logo_league_auth_arr}
                          val={logo_league_auth ? 1 : 0}
                          action={set_logo_league_auth}
                          size={4}
                        />
                        :
                        <SingleText
                          val={get_logo_league_auth_string(logo_league_auth)}
                          size={4} color={'default'} />
                    }
                  </div>
                  <p>&nbsp;</p>
                  {
                    isEdit ?
                      <div className="user-button">
                        <div className="row">
                          {file === undefined ?
                            <div className="col-md-6">
                              <input className="btn" type="file" name="file" accept="" onChange={e => setFile(e.target.files[0])} />
                            </div>
                            : <UploadButtonSM action={upload_logo_league} id={logo_league} name={"上傳"} size={6} />
                          }
                          <UploadButtonSM action={delete_logo_league} id={logo_league} name={"刪除"} size={6} color={"btn-default"} icon={"fa-trash"} />
                        </div>
                      </div>
                      : <></>}
                </div>
              </div>
            </div> */}
          </div>

          <div className="col-md-6">
            <div className="col-md-12">
              {isEdit ?
                <SingleInput title={"中文名稱"} val={league_name} action={set_league_name} action_blur={checkName} placeholder={"中華職業棒球大聯盟"} size={8} />
                : <SingleText title={"中文名稱"} val={league_name} size={8} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"球隊總數"} val={team_acount} size={4} />
              }

            </div>
            {isCheckRepeat ?
              <div className="col-md-12">
                <div className="col-md-8">
                  <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
                </div>
              </div>
              : <></>}
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="col-md-12">
              {isEdit ?
                <SingleInput title={"英文名稱"} val={league_name_eng} action={set_league_name_eng} placeholder={"Chinese Professional Baseball League"} size={8} />
                : <SingleText title={"英文名稱"} val={league_name_eng} size={8} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"編號"} val={_id} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="col-md-12">
              {
                isEdit ?
                  <SingleRedio title={"啟停用"}
                    arr={activation_Items}
                    val={league_activation ? 1 : 0}
                    action={set_league_activation}
                    size={4}
                  />
                  :
                  <SingleText title={"啟停用"}
                    val={get_activation_string(league_activation)}
                    size={4} />
              }
              {
                isEdit ?
                  <SingleSelect title={"賽事類型"}
                    val={league_type}
                    attr={league_type_attr}
                    action={set_league_type}
                    valType={SELECT_VAL_TYPE_INT}
                    hasBlank={true}
                    blankVal={0}
                    size={4}
                  />
                  :
                  <SingleText title={"賽事類型"}
                    val={get_league_type_string(league_activation)}
                    size={4} />
              }
              {isAdd ?
                <></>
                : <SingleText title={"異動日期"} val={league_last_change} size={4} />
              }

            </div>
            <Space />
            <Space />
            <Space />
            <Space />
            <div className="col-md-12">
              {isEdit ?
                <SingleInput title={"註記"} val={league_note} action={set_league_note} placeholder={"內部人員註記"} size={12} />
                : <SingleText title={"註記"} val={league_note} size={12} />
              }
            </div>
          </div>



        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-md-12">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}